import { LicensesSet } from "../../mp-database"
import { getProgramByLicenseName } from "../../mp-core/helpers/getProgramByLicenseName"

export const hasValidLicenses = (userLicenses: LicensesSet[]): boolean => {
  if (!userLicenses || userLicenses.length === 0) {
    return false
  }

  // Check if any licenses are not expired and not deleted
  // Note: licensable defaults to true if undefined, deleted defaults to false if undefined
  return userLicenses.some(
    license =>
      !license.isExpired && !license.deleted && license.licensable !== false // Only reject if explicitly false
  )
}

export const getProgramsFromLicenses = (
  userLicenses: LicensesSet[]
): string[] => {
  const programs = new Set<string>()

  userLicenses.forEach(license => {
    // Same validation as hasValidLicenses: licensable defaults to true if undefined
    if (
      !license.isExpired &&
      !license.deleted &&
      license.licensable !== false
    ) {
      const program = getProgramByLicenseName(license.name)
      if (program) {
        programs.add(program)
      }
    }
  })

  return Array.from(programs)
}

export const isProgramLicensed = (
  program: string,
  userLicenses: LicensesSet[]
): boolean => {
  const licensedPrograms = getProgramsFromLicenses(userLicenses)
  const programLower = program.toLowerCase()

  // Check for direct program match
  if (licensedPrograms.includes(programLower)) {
    return true
  }

  return false
}
